<template>
    <v-dialog v-model="dialog" max-width="400" @keydown.esc="chiudiDialog()" persistent>
        <v-card>
            <v-card-title>Prepara per fatturazione</v-card-title>

            <v-card-text class="mb-4">
                <v-row>
                    <v-col cols="12">
                        <v-menu ref="menu" v-model="menuDate" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="selectedDateIT" label="Mese e anno" prepend-icon="calendar_month"
                                    readonly v-bind="attrs" v-on="on" hide-details />
                            </template>

                            <!-- Date Picker limitato alla selezione di mese/anno -->
                            <v-date-picker v-model="selectedDate" type="month" @input="menuDate = false" locale="it"
                                scrollable />
                        </v-menu>
                    </v-col>

                    <v-btn small style="width: 100%;" @click="rimuoviFattura()">Rimuovi fatturazione</v-btn>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-btn text @click="chiudiDialog()">
                    Chiudi
                </v-btn>
                <v-spacer />

                <v-btn color="primary" @click="confermaFatturazione">
                    Conferma
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
import { prepara_fattura } from "@/api/api.documenti.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        nrDocu: { type: String, default: "-1" },
        mese: { type: String, default: "" }
    },

    data: () => ({
        selectedDate: null,
        selectedDateIT: null,
        menuDate: false,
        stato: 0,
    }),

    methods: {
        chiudiDialog() {
            this.$emit("chiudi", this.selectedDate, this.stato);
        },

        rimuoviFattura() {
            this.stato = 0;
            this.selectedDate = null;
            this.confermaDati(null);
        },

        confermaFatturazione() {
            this.stato = 1;
            let data = new Date(this.selectedDate + "-01");
            data = data.toISOString().split("T")[0];
            this.confermaDati(data);
        },

        async confermaDati(data) {
            let par = {
                Stato: this.stato,
                NrDocu: this.nrDocu,
                DtModifica: data
            }
            let res = await prepara_fattura(par)
            if (res.data == "OK") this.chiudiDialog();
            else this.$toast.alert(res.data);
        },
    },

    watch: {
        dialog(newVal) {
            if (!newVal || !this.mese) return;
            if (this.mese.split("/").length != 3) return;
            let [day, month, year] = this.mese.split("/");
            this.selectedDate = new Date(year, month, day).toISOString().substring(0, 7);
            //this.selectedDateIT = new Date(year, month - 1, day).toLocaleDateString("it-IT");
        },

        selectedDate(newVal) {
            if (!newVal) this.selectedDateIT = null;
            this.selectedDateIT = new Date(newVal).toLocaleDateString("it-IT");
        }
    }
}
</script>